import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ActiveStoreState {
  activeStoreId: number | null;
  setActiveStoreId: (id: number | null) => void;
}

export const useActiveStore = create<ActiveStoreState>()(
  persist(
    (set) => ({
      activeStoreId: null,
      setActiveStoreId: (id) => set({ activeStoreId: id }),
    }),
    {
      name: "trendrain-active-store",
    },
  ),
);
